import { render, staticRenderFns } from "./Antecedentes.vue?vue&type=template&id=da0a28ea&"
import script from "./Antecedentes.vue?vue&type=script&lang=js&"
export * from "./Antecedentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports